import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {DocumentType} from '../../models/io/documentType';
import {of} from 'rxjs';
import {take} from 'rxjs/operators';

@Component({
    selector: 'lv-document-viewer-page',
    templateUrl: './documentViewerPage.component.html',
    standalone: false
})
export class DocumentViewerPageComponent implements AfterViewInit, OnChanges {

  @ViewChild('canvas', {read: ElementRef, static: true})
  public canvas: ElementRef;
  @Input()
  public type: DocumentType;
  @Input()
  public index: number;
  @Input()
  public documentProxy: any;
  @Input()
  public zoomLevel = 100;
  @Input()
  public rotation = 0;

  private rendered: boolean;
  private _lastRenderTask: any | undefined;

  constructor(private _elementRef: ElementRef) {
  }

  @HostListener('window:resize')
  public onResize(): void {
    this._renderPage();
  }

  public ngAfterViewInit(): void {
    this._renderPage();
  }


  public ngOnChanges(changes: SimpleChanges): void {
    if (this.rendered) {
      this._renderPage();
    }
  }

  private _renderPage(): void {
    switch (this.type) {
      case DocumentType.PDF:
        this._renderPdfPage();
        break;
    }
  }

  private _renderPdfPage(): void {
    if (this._lastRenderTask) {
      this._lastRenderTask.cancel();
    }
    this.documentProxy.getPage(this.index + 1).then((page/*: PDFPageProxy */) => {
      const rotate = this.rotation % 360;
      let viewport = page.getViewport({scale: 1, rotate});
      viewport = page.getViewport({
        scale: this._elementRef.nativeElement.offsetWidth / viewport.width * (this.zoomLevel / 100),
        rotate
      });
      const canvas = this.canvas.nativeElement;
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const renderContext = {
        canvasContext: context,
        viewport,
      };
      this._lastRenderTask = page.render(renderContext);
      of(this._lastRenderTask).pipe(take(1)).subscribe(() => {
        this._lastRenderTask = void 0;
        this.rendered = true;
      });
      /*
      this._lastRenderTask.then(() => {
        this._lastRenderTask = void 0;
        this.rendered = true;
      }).catch(() => {
      });*/
    });
  }
}
